import React from 'react';
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';
import './partner.component.scss';
import { LowerParticlesComponent } from '../../components/lower-particles/lower-particles.component';

export const PartnerComponent = () => {
  return (
    <>
      <Helmet>
        <title>Web制作パートナー募集｜ヴィーゾフ -Viezof-</title>
        <meta name="description" content="ヴィーゾフでは、Webサイトのコーディング、WordPressを中心としたCMS構築・改修、Webデザインにご協力いただけるパートナーを募集しています。フリーランスの方を中心に制作会社様も歓迎。全国からご応募いただけます。" />
      </Helmet>
      <div className="partner">
        <div className="partner__page_title c-page_title">
          <h1 className="c-page_title__txt">Partner<span className="c-page_title__txt__ja">パートナー募集</span></h1>
        </div>
        <div className="partner__conts">
          <LowerParticlesComponent />
          <div className='c-lower_content'>
            <p>ヴィーゾフでは、Webサイト制作にご協力いただけるパートナー様を募集しております。<br/>
            フリーランスの方を中心に、制作会社様からのご相談も歓迎しております。<br/>
            お住まいや拠点の地域を問わず、全国からご応募いただけます。</p>

            <p>下記の募集要項をご確認の上、スキルや実績を添えてお問い合わせフォームよりご応募ください。<br/>
            また、パートナー様で対応しきれない案件について、ヴィーゾフにご依頼いただくことも可能ですので、お気軽にご相談ください。</p>

            <p>切磋琢磨しながら、共に成長できるパートナー様と一緒にお仕事ができれば幸いです！</p>

            <section className="partner__conts__section c-lower_content__section">
              <h2 className="partner__conts__section__ttl c-ttl__02">Webコーディング・CMS構築</h2>
              <p>HTML/CSSやJavaScriptを用いたWebサイトのコーディング、およびWordPressを中心としたCMSの組み込み・構築・改修を主にご依頼いたします。<br/>
              また、ReactやAngularなどのフレームワークを使用したWebサイトのフロントエンド実装についても、お持ちのスキルに応じてご相談させていただきます。</p>
            </section>

            <section className="partner__conts__section c-lower_content__section">
              <h2 className="partner__conts__section__ttl c-ttl__02">Webデザイン</h2>
              <p>Webサイトのデザイン制作を主にご依頼いたします。また、イラストの作成や写真撮影などについても、案件の内容やお持ちのスキルに応じてご相談させていただきます。</p>
            </section>

            <section className="partner__conts__section c-lower_content__section">
              <h2 className="partner__conts__section__ttl c-ttl__02">ご応募について</h2>
              <p>ご協力いただける方は、お問い合わせフォームよりご連絡ください。お問い合わせ種別で「制作パートナーに関するお問い合わせ」を選択し、お問い合わせ内容に以下をご記載ください。</p>
              <ul>
                <li>簡単なプロフィール・得意分野</li>
                <li>実績やポートフォリオのURL、および各実績での担当範囲</li>
                <li>稼働可能な時期・時間の目安</li>
              </ul>
              <p>内容を確認の上、折り返しメールにてご連絡差し上げます。</p>
              <p>※案件の状況やご経験・ご希望に応じてご相談するため、ご連絡後すぐに案件をご案内できない場合がございます。</p>
            </section>

            <div className="partner__conts__contact c-btn__01">
              <Link to="/contact">パートナーについて相談する</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
